import vitor from "../roster/photos/ vitor.jpg";
import arthur from "../roster/photos/arthur.jpg";
import be from "../roster/photos/be.jpg";
import carlos from "../roster/photos/carlos.jpg";
import clovis from "../roster/photos/clovis.jpg";
import davia from "../roster/photos/davia.jpg";
import davis from "../roster/photos/davis.jpg";
import inigo from "../roster/photos/inigo.jpg";
import diego from "../roster/photos/diego.jpg";
import elijah from "../roster/photos/elijah.jpg";
import enzo from "../roster/photos/enzo.jpg";
import erik from "../roster/photos/erik.jpg";
import feijo from "../roster/photos/feijo.jpg";
import felipao from"../roster/photos/felipao.jpg";
import fred from "../roster/photos/fred.jpg"
import gabriel from "../roster/photos/gabriel.jpg";
import gui from "../roster/photos/gui.jpg";
import guido from "../roster/photos/guido.jpg";
import henri from "../roster/photos/henri.jpg"
import indaias from "../roster/photos/indaias.jpg"
import isaac from "../roster/photos/isaac.jpg"
import japa from "../roster/photos/japa.jpg"
import joca from "../roster/photos/joca.jpg"
import jola from "../roster/photos/jola.jpg"
import jon from "../roster/photos/jon.jpg"
import kg from "../roster/photos/kg.jpg"
import lethabo from "../roster/photos/lethabo.jpg"
import matheus from "../roster/photos/matheus.jpg"
import miguel from "../roster/photos/miguel.jpg"
import nicollas from "../roster/photos/nicollas.jpg"
import pacheco from "../roster/photos/pacheco.jpeg"
import pg from "../roster/photos/pg.jpg"
import raph from "../roster/photos/raph.jpg"
import raul from "../roster/photos/raul.jpg"
import renan from "../roster/photos/renan.jpg"
import stoll from "../roster/photos/stoll.jpg"
import theo from "../roster/photos/theo.jpg"
import thomas from "../roster/photos/thomas.jpg"
import varanda from "../roster/photos/varanda.jpg"
import yan from "../roster/photos/yan.jpg"


export const stats = {

        1:{
                p_name: "Bernardo",
                image: be,
                goals: null,
                assists: null,
                clean:6
        },

        2:{
                p_name: "Iñigo",
                image: inigo,
                goals: null,
                assists: null,
                clean:3
        },

        3:{
                p_name: "Diego",
                image: diego,
                goals: null,
                assists: null,
                clean:4
        },


        4:{
                p_name: "Gabriel",
                image: gabriel, 
                goals: 0,
                assists: 0
        },

        5:{
                p_name: "Guilherme",
                image: gui, 
                goals: 1,
                assists: 4
        },

        6:{
                p_name: "PG",
                image: pg, 
                goals: 0,
                assists: 0
        },

        7:{
                p_name: "Jola",
                image: jola, 
                goals: 0,
                assists: 2
        },

        8:{
                p_name: "Varanda",
                image: varanda, 
                goals: 2,
                assists: 0
        },

        9:{
                p_name: "Guido",
                image: guido, 
                goals: 0,
                assists: 0
        },

        10:{
                p_name: "Matheus",
                image: matheus, 
                goals: 2,
                assists: 0
        },

        11:{
                p_name: "Miguel",
                image: miguel, 
                goals: 0,
                assists: 0
        },

        12:{
                p_name: "Nicolas",
                image: indaias, 
                goals: 2,
                assists: 11
        },

        13:{
                p_name: "Theo",
                image: theo, 
                goals: 2,
                assists: 6
        },

        14:{
                p_name: "Thomas",
                image: thomas, 
                goals: 1,
                assists: 2
        },

        15:{
                p_name: "KG",
                image: kg, 
                goals: 0,
                assists: 0
        },

        16:{
                p_name: "Yan",
                image: yan, 
                goals: 1,
                assists: 1
        },

        17:{
                p_name: "Davi A",
                image:davia, 
                goals: 1,
                assists: 0
        },

        18:{
                p_name: "Davi S",
                image: davis, 
                goals: 1,
                assists: 1
        },

        19:{
                p_name: "Fred",
                image: fred, 
                goals: 6,
                assists: 3
        },

        20:{
                p_name: "Stoll",
                image: stoll, 
                goals: 0,
                assists: 2
        },

        21:{
                p_name: "Joaquim",
                image: joca, 
                goals: 2,
                assists: 0
        },

        22:{
                p_name: "Lethabo",
                image: lethabo, 
                goals: 0,
                assists: 0
        },

        23:{
                p_name: "Pacheco",
                image: pacheco, 
                goals: 2,
                assists: 2
        },

        24:{
                p_name: "Raphael",
                image: raph, 
                goals: 1,
                assists: 4
        },

        25:{
                p_name: "Raul",
                image: raul, 
                goals: 0,
                assists: 0
        },

        26:{
                p_name: "Arthur",
                image: arthur, 
                goals: 4,
                assists: 5
        },

        27:{
                p_name: "Clovis",
                image: clovis, 
                goals: 5,
                assists: 1
        },

        28:{
                p_name: "Erik",
                image: erik, 
                goals: 3,
                assists: 0
        },

        29:{
                p_name: "Feijó",
                image: feijo, 
                goals: 4,
                assists: 0
        },

        30:{
                p_name: "Felipe",
                image: felipao, 
                goals: 14,
                assists: 4
        },

        31:{
                p_name: "Isaac",
                image: isaac, 
                goals: 4,
                assists: 2
        },

        32:{
                p_name: "Renan",
                image: renan, 
                goals: 4,
                assists: 5
        },

        33:{
                p_name: "Vitor Y",
                image: japa, 
                goals: 7,
                assists: 2
        },

        34:{
                p_name: "Carlos",
                image: carlos, 
                goals: 0,
                assists: 0
        },

        35:{
                p_name: "Elijah",
                image: elijah, 
                goals: 0,
                assists: 0
        },

        36:{
                p_name: "Enzo",
                image: enzo, 
                goals: 0,
                assists: 0
        },

        37:{
                p_name: "Nicollas",
                image: nicollas, 
                goals: 0,
                assists: 0
        },

        38:{
                p_name: "Jonatas",
                image: jon, 
                goals: 0,
                assists: 0
        },

        39:{
                p_name: "Henri",
                image: henri, 
                goals: 0,
                assists: 2
        },

        40:{
                p_name: "Vitor M",
                image: vitor, 
                goals: 4,
                assists: 0
        },




}

